import { getSessionStorage } from '../../../utils/enhancedSessionStorage'
import { FEATURES, MODULES } from '../constants/template-info'
import { LocalStorageData } from '../domains/contentful/LocalStorageDataWithExpiry'

import { captureException } from './sentryUtil'

export const setInSessionStorageWithExpiry = (
  key: string,
  value: string,
  expiryInMinutes?: number,
  isGlobal = true, // Default to global for backward compatibility
) => {
  try {
    const now = new Date()
    // @i18n-ignore
    const MAX_EXPIRY_DATE_IN_EPOCH_MILLESECONDS = new Date('Fri, 18 May 2035 12:00:00 UTC').getTime()
    const data: LocalStorageData = {
      key: key,
      value: value,
      expiryInMs: expiryInMinutes ? now.getTime() + expiryInMinutes * 60 * 1000 : MAX_EXPIRY_DATE_IN_EPOCH_MILLESECONDS,
    }
    // Use enhanced session storage for locale support
    const sessionStorage = getSessionStorage()
    sessionStorage.setItem(key, JSON.stringify(data), { isGlobal })
  } catch (error) {
    captureException('setInSessionStorageWithExpiry error', {
      module: MODULES.SESSION_STORAGE,
      feature: FEATURES.SET_IN_SESSION_STORAGE_WITH_EXPIRY,
      extraInfo: {
        // @i18n-ignore
        capturedFrom: 'Set in session storage with expiry function',
        sessionStorageKey: key,
        sessionStorageValue: value,
        errorDetail: JSON.stringify(error),
      },
    })
  }
}

/**
 * Enhanced version with explicit locale support
 * @param key - The key to store
 * @param value - The value to store
 * @param expiryInMinutes - Expiry time in minutes (optional)
 * @param isGlobal - Whether data should be shared across languages (default: false)
 */
export const setInSessionStorageWithExpiryLocalized = (
  key: string,
  value: string,
  expiryInMinutes?: number,
  isGlobal = false, // Default to localized for new usage
) => {
  setInSessionStorageWithExpiry(key, value, expiryInMinutes, isGlobal)
}
